<template>
	<v-container ref="fullPage" :style="darkTheme ? 'background-color: black;' : 'background-color: white;'" 
	style="z-index: 100;" fluid 
	class="fullpage">
	<v-toolbar height="80">
	  				  
		    <v-flex xs3>
            </v-flex>
            <v-flex class = "ml-3">
			  	<v-toolbar-title class="ml-5 topTitle">	
			  			<v-layout align-center row fill-height>			
						<img src="@/images/ua_block_rgb_3.3c82a4c.png" class="blocka">
						<a href="/roomviewer" 
							style="text-decoration: none;"
							:style="darkTheme ? 'color: whitesmoke;' : 'color: black;'"> 
								Room Viewer 
						</a>						
					 	</v-layout>
				</v-toolbar-title>	
			</v-flex>			
				{{this.userProfile.netid}}
				<v-icon v-if="isSuperUser" medium color="red" class="pl-2">verified_user</v-icon>
				<DBToggleBtn/>			
	        <v-btn large icon class="grey--text text--darken-2" 
	        	@click="mapReload">
	        	<v-icon large >close</v-icon>
	        </v-btn>

  		</v-toolbar>
  		<v-card class="pa-4">
  			<v-layout row align-center>
	  			<v-flex >
	  			<v-autocomplete outline	
						v-on:change="selectBuilding"	
						v-model="building"						
						hide-no-data
						hide-details
						auto-select-first
						autocomplete
						clearable
						style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
						:items="buildings"
						:filter="customFilter"
						label="Building Name / Number / Addr"
						single-line
						return-object
						:key="resetAutoBuilding"
						>
						<template
					        slot="selection"
					        slot-scope="{ item, tile }"
					      >
					      	<v-layout >
					        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
					        	{{item.bldgAlpha}}
					        </v-list-tile-avatar>
					        <v-list-tile-content>
					          <v-list-tile-title>
					          	{{item.name}}
					          </v-list-tile-title>
					          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
					        </v-list-tile-content>
					    	</v-layout>
					      </template>
						<template
					        slot="item"
					        slot-scope="{ item, tile }"
					      >
					        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
					        	{{item.bldgAlpha}}
					        </v-list-tile-avatar>
					        <v-list-tile-content>
					          <v-list-tile-title>
					          	{{item.name}}
					          </v-list-tile-title>
					          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
					        </v-list-tile-content>
					      </template>
					</v-autocomplete>				
				</v-flex>
				<v-flex class="mx-4" >
					<AutocompleteCollege  
					:key="resetAutoCollege"
					:changeHandler="getCollegeRooms"	
	                class=""     
	                :outline="true" 
	                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"          
	                 /> 
	                <!-- v-on:return-selection="changeHandler"  -->
	            </v-flex>
				<v-flex>
					<AutocompleteDepartment 
					:key="resetAutoDepartment"
					:changeHandler="getDepartmentRooms"
	                class=""     
	                :outline="true" 
	                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" 
	                 /> 
	                <!-- v-on:return-selection="changeHandler"  -->
	            </v-flex>
	            
	            <v-flex shrink class="ml-5">
	            	<v-checkbox v-model="showOccupantsPIs" label="Occupants, PIs, User Depts">
	            		<template v-slot:label>
					        Occupants, PIs, User Depts
					        <v-progress-circular color="primary" :indeterminate="loading" :value="0" size="24" class="ml-2"></v-progress-circular>
					      </template>
	            	</v-checkbox>
	            </v-flex>
        	</v-layout>
  		</v-card>
  		<RoomGrid v-if="roomBucket" />
  		<v-flex v-else class="mt-4 ml-4">
  			<v-btn v-if="building" @click="createNewRoom(building)">Add Rooms</v-btn>
  		</v-flex>
  		<RoomDetail class="pr-4" style="position: absolute; width: 100%; bottom: 0px;"  v-if="room" />
  		<BulkRoomEditSideBarDV v-on:refresh='refreshRooms()' />
  	</v-container>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import DBToggleBtn from '@/components/DBToggleBtn'
import RoomGrid from '@/components/RoomViewer/RoomGrid'
import AutocompleteCollege from '@/components/forms/AutocompleteCollege.vue'
import AutocompleteDepartment from '@/components/forms/AutocompleteDepartment.vue'
import RoomDetail from '@/components/RoomViewer/RoomDetail'
import BulkRoomEditSideBarDV from '@/components/RoomViewer/BulkRoomEditSideBarDV'


export default {
data () {
	return { 	building: null,
				// incrementing the key on a vue object is a cheap way of resetting it.
				resetAutoDepartment: 100,
				resetAutoCollege: 200,
				resetAutoBuilding: 300,
				showOccupantsPIs: false,
				loading:false,
	}
},

created: async function () {
	if (this.buildings.length > 0 && this.$route.params.rvbldg) { 
		this.building = this.getBuilding(this.$route.params.rvbldg)
		await this.getBuildingRooms(this.building)
		if (this.$route.params.rvroom) { 
			this.selectedRoom = this.$route.params.rvroom
		}
	}
},

watch: {
	// Check for routing after required lists have loaded.
	async buildings (val) { 
		if (this.$route.params.rvbldg) { 
			this.building = this.getBuilding(this.$route.params.rvbldg)
			await this.getBuildingRooms(this.building)
			if (this.$route.params.rvroom) { 
				this.selectedRoom = this.$route.params.rvroom
			}
		}
	},

	async depts (val) { 
		if (this.$route.params.deptID) { 
			this.getDepartmentRooms({ deptID: this.$route.params.deptID })	
			let department = this.getDepartment(this.$route.params.deptID)
			this.setDeptSync(department)	
		}
	},

	async colleges (val) { 
		if (this.$route.params.collegeID) { 
			this.getCollegeRooms({ id: this.$route.params.collegeID })	
			let college = this.getCollege(this.$route.params.collegeID)
			this.setCollegeSync(college)	
		}
	},

	async showOccupantsPIs (val) {	// only one of these will execute
		console.log("Watch checkbox fired")
			this.getBuildingRooms(this.building)
			this.getDepartmentRooms(this.deptSync)
			this.getCollegeRooms(this.collegeSync)
		}
},

components : { DBToggleBtn, RoomGrid, RoomDetail, AutocompleteCollege, AutocompleteDepartment, BulkRoomEditSideBarDV  },

computed: {
	...mapState({   	darkTheme: state => state.ui.darkTheme,
						userProfile: state => state.user.userProfile,
						isSuperUser: state => state.user.isSuperUser,
						roomBucket: state => state.roomViewer.roomBucket,
						buildings: state => state.space.buildings,
						room: state => state.dv.room,
						depts: state => state.lists.depts,
						colleges: state => state.lists.colleges,
						collegeSync: state => state.roomViewer.collegeSync,
						deptSync: state => state.roomViewer.deptSync
				}),
	...mapGetters([		'getBuilding', 'getDepartment', 'getCollege']),

	selectedRoom : {
	    get () {
	    	return this.$store.state.dv.room ? this.$store.state.dv.room.number : null
	    },
	    set (value) {
	        this.fetchFullRoom({bldgAlpha: this.building.bldgAlpha, number: value, noSet: true}).then((data) => { 
			this.setRoom(data) 
			this.loading = false
			})
	    }
	},
	
},

methods : {
	...mapMutations([ 	'setBuildings',
						'setRoomBucket',
						'setBucketType',
						'setSnackText',
						'setDeptSync',
						'setCollegeSync',
						'createNewRoom',
						'setdvBuildingOnly',
						'setBuilding'
					]),
	...mapActions([ 	'fetchBuildingRooms',
						'fetchBuildingRoomsFull',
						'fetchCollegeRooms',
						'fetchCollegeRoomsFull',
						'fetchDepartmentRooms',
						'fetchDepartmentRoomsFull',
						'fetchFullRoom',
						'setRoom',
					]),


	mapReload: function () {
        //window.location = "/";
        this.$router.push({ name: 'home' })
    },

    setrvBuilding(building) {  // This just sets route
		
		if (building) {
			console.log("Set Route ", { name: 'RoomViewerToBldg', params: { bldg: building.bldgAlpha }})
			
			//Set state building. This was not being done previously and was causing problems when trying to add a new room as building was not defined in the state
			//4/25/24 rwm
			console.log("Set state dv.building and space.selectedBuilding", {building});
			//this.setdvBuildingOnly(building);
			this.setBuilding(building);
			this.setdvBuildingOnly(building);

			this.$router.push({
				name: "RoomViewerToBldg",
				params: { rvbldg: building.bldgAlpha }
			});
			
		}
	},

    customFilter (item, queryText, itemText) {
		//return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
		
        const bldgAlpha = item.bldgAlpha.toLowerCase()
        const searchBlob = 	item.bldgAlpha + item.name + item.address + item.city + item.state + item.abbrev + 
        					item.commonName + item.shortName + item.aliasName

        // If Search is 3 or less, use only the bldgAlpha.  Otherwise search the blob.
        if (queryText.length > 3 ) {
        	return searchBlob.toLowerCase().indexOf(queryText.toLowerCase()) > -1
        } else {
        	return bldgAlpha.indexOf(queryText.toLowerCase()) > -1 
        }
    },

    selectBuilding(building) {
    	this.setrvBuilding(building)
    	this.getBuildingRooms(building)
    },

    getBuildingRooms: async function (building) {
    	this.setRoom(null)    	
    	//console.log("Get Building Rooms")
    	if (!building) { this.setRoomBucket(null); /*console.log("Abort");*/ return; }
    	this.resetAutoDepartment = this.resetAutoDepartment + 1
    	this.resetAutoCollege = this.resetAutoCollege + 1
    	this.setDeptSync(null)
    	this.setCollegeSync(null)
    	
    	this.setRoomBucket([]) // This turns on the loading bar
    	this.setBucketType("building")
    	let rooms = null  

    	if (this.showOccupantsPIs) {
    		this.loading = true
    		rooms = await this.fetchBuildingRoomsFull(building.bldgAlpha)
    		this.loading = false
    	} else {
    		rooms = await this.fetchBuildingRooms(building.bldgAlpha)
    	}

    	if (rooms.length > 0) {
    		this.setRoomBucket(rooms)
    		return rooms
    	}
    	else { 
    		this.setSnackText("No Rooms for this Building")
    		this.setRoomBucket(null)
    		return null
    	}   	
    },

    getCollegeRooms: async function (college) {
    	//console.log("Get College Rooms")
    	if (!college) { this.setRoomBucket(null); /*console.log("Abort");*/ return;}
    	this.setCollegeSync(college)	
    	this.resetAutoBuilding = this.resetAutoBuilding + 1
    	this.building = null
    	this.resetAutoDepartment = this.resetAutoDepartment + 1
    	this.setDeptSync(null)
    	
    	this.setRoomBucket([]) // This turns on the loading bar
    	this.setBucketType("college")
    	let rooms = null
    	if (this.showOccupantsPIs) {
			this.loading = true
    		rooms = await this.fetchCollegeRoomsFull(college.id)
			this.loading = false
    	} else {
    		rooms = await this.fetchCollegeRooms(college.id)
    	}
    	if (rooms.length > 0) {
    		this.setRoomBucket(rooms)
    		return rooms
    	}
    	else { 
    		this.setSnackText("No Rooms for this College")
    		this.setRoomBucket(null)
    		return null
    	}    	
    },



    getDepartmentRooms: async function (department) {
    	//console.log("Get Department Rooms")
    	if (!department) { this.setRoomBucket(null); /*console.log("Abort", department);*/ return; }
    	this.setDeptSync(department)
    	this.resetAutoBuilding = this.resetAutoBuilding + 1
    	this.building = null
    	this.resetAutoCollege = this.resetAutoCollege + 1
    	this.setCollegeSync(null)
    	
    	this.setRoomBucket([]) // This turns on the loading bar
    	this.setBucketType("department")
    	let rooms = null
    	if (this.showOccupantsPIs) {
			this.loading = true
    		rooms = await this.fetchDepartmentRoomsFull(department.deptID)
			this.loading = false
    	} else {
    		rooms = await this.fetchDepartmentRooms(department.deptID)
    	}

    	//console.log(rooms)
    	if (rooms.length > 0) {
    		this.setRoomBucket(rooms)
    		return rooms
    	}
    	else { 
    		this.setSnackText("No Rooms for this Department")
    		this.setRoomBucket(null)
    		return null
    	}    	    	
    },

	async refreshRooms() {
		await this.getBuildingRooms(this.building)
	},
},
}

</script>

<style>
.fullpage {
display: absolute;
flex-direction: column;
flex: 1;
z-index: 10;
position: fixed;
top: 0px;
width: 100vw;
background-color: rgba(255, 255, 255, 1);
padding: 0px !important;
margin-top: 0px;
height: 100%;
overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomViewer.vue